<template>
	<v-row no-gutters>
		<v-col>
			<video
					class="video-js vjs-fluid customVideo video_"
					ref="videoPlayer"
					@click.right.prevent="$_crsVd_click()"
					@click="$_crsVd_click()" />
			<template v-if="video_.paused || video_.ended">
				<v-card class="card_" tile color="#333333cc">
					<v-row class="row_" align="center" justify="center">
						<v-col cols="auto">
							<v-row>
								<v-col class="center">
									<v-btn	class="customVBtn"
											:block="$_crsVd_styleVideoOpenLinkButtonBlock"
											:color="$_crsVd_styleVideoOpenLinkButtonColor"
											:dark="$_crsVd_styleVideoOpenLinkButtonDark"
											:depressed="$_crsVd_styleVideoOpenLinkButtonDepressed"
											:elevation="$_crsVd_styleVideoOpenLinkButtonElevation"
											:large="$_crsVd_styleVideoOpenLinkButtonLarge"
											:light="$_crsVd_styleVideoOpenLinkButtonLight"
											:outlined="$_crsVd_styleVideoOpenLinkButtonOutlined"
											:rounded="$_crsVd_styleVideoOpenLinkButtonRounded"
											:small="$_crsVd_styleVideoOpenLinkButtonSmall"
											:text="$_crsVd_styleVideoOpenLinkButtonFlat"
											@click="openLink($_crsVd_link)"
											v-text="$_crsVd_langVideoOpenLinkButton" />
								</v-col>
							</v-row>
							<template v-if="video_.paused">
								<v-row dense>
									<v-col class="center">
										<v-btn	class="customVBtn"
												:block="$_crsVd_styleVideoResumeButtonBlock"
												:color="$_crsVd_styleVideoResumeButtonColor"
												:dark="$_crsVd_styleVideoResumeButtonDark"
												:depressed="$_crsVd_styleVideoResumeButtonDepressed"
												:elevation="$_crsVd_styleVideoResumeButtonElevation"
												:large="$_crsVd_styleVideoResumeButtonLarge"
												:light="$_crsVd_styleVideoResumeButtonLight"
												:outlined="$_crsVd_styleVideoResumeButtonOutlined"
												:rounded="$_crsVd_styleVideoResumeButtonRounded"
												:small="$_crsVd_styleVideoResumeButtonSmall"
												:text="$_crsVd_styleVideoResumeButtonFlat"
												@click="$_crsVd_play()"
												v-text="$_crsVd_langVideoResumeButton" />
									</v-col>
								</v-row>
							</template>
							<template v-if="video_.ended">
								<v-row dense>
									<v-col class="center">
										<v-btn	class="customVBtn"
												:block="$_crsVd_styleVideoReplayButtonBlock"
												:color="$_crsVd_styleVideoReplayButtonColor"
												:dark="$_crsVd_styleVideoReplayButtonDark"
												:depressed="$_crsVd_styleVideoReplayButtonDepressed"
												:elevation="$_crsVd_styleVideoReplayButtonElevation"
												:large="$_crsVd_styleVideoReplayButtonLarge"
												:light="$_crsVd_styleVideoReplayButtonLight"
												:outlined="$_crsVd_styleVideoReplayButtonOutlined"
												:rounded="$_crsVd_styleVideoReplayButtonRounded"
												:small="$_crsVd_styleVideoReplayButtonSmall"
												:text="$_crsVd_styleVideoReplayButtonFlat"
												@click="$_crsVd_replay()"
												v-text="$_crsVd_langVideoReplayButton" />
									</v-col>
								</v-row>
							</template>
						</v-col>
					</v-row>
				</v-card>
			</template>
		</v-col>
	</v-row>
</template>

<script>
	export default {
		name: 'CarouselVideo',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		data() {
			return {
				player_: null,

				video_: {
					play: false,
					paused: false,
					ended: false
				}
			}
		},
		computed: {
			// info
			// (content)
			$_crsVd_video() {
				const self_ = this;
				return self_.contents[self_.contentKey].video
			},
			$_crsVd_videoAutoPlay() {
				const self_ = this;
				const video_ = self_.$_crsVd_video;
				return video_.autoPlay
			},
			$_crsVd_videoControls() {
				const self_ = this;
				const video_ = self_.$_crsVd_video;
				return video_.controls
			},
			$_crsVd_videoMuted() {
				const self_ = this;
				const video_ = self_.$_crsVd_video;
				return video_.muted
			},
			$_crsVd_videoLoadingImage() {
				const self_ = this;
				const video_ = self_.$_crsVd_video;
				return self_.getStylesVal(video_.loadingImage)
			},
			$_crsVd_videoReadyImage() {
				const self_ = this;
				const video_ = self_.$_crsVd_video;
				return self_.getStylesVal(video_.readyImage)
			},
			$_crsVd_videoUrl() {
				const self_ = this;
				const video_ = self_.$_crsVd_video;
				return self_.getStylesVal(video_.url)
			},
			// lang
			$_crsVd_langVideoResumeButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'videoResumeButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_crsVd_langVideoReplayButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'videoReplayButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_crsVd_langVideoOpenLinkButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'videoOpenLinkButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			// link
			// (content)
			$_crsVd_link() {
				const self_ = this;
				return self_.contents[self_.contentKey].link
			},
			// style
			$_crsVd_styleVideoResumeButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'videoResumeButton')
			},
			$_crsVd_styleVideoResumeButtonBlock() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoResumeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_crsVd_styleVideoResumeButtonColor() {
				const self_ = this;
				const button_ =self_.$_crsVd_styleVideoResumeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_crsVd_styleVideoResumeButtonDark() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoResumeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_crsVd_styleVideoResumeButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoResumeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_crsVd_styleVideoResumeButtonElevation() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoResumeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_crsVd_styleVideoResumeButtonFlat() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoResumeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_crsVd_styleVideoResumeButtonLarge() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoResumeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_crsVd_styleVideoResumeButtonLight() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoResumeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_crsVd_styleVideoResumeButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoResumeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_crsVd_styleVideoResumeButtonRounded() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoResumeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_crsVd_styleVideoResumeButtonSmall() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoResumeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_crsVd_styleVideoReplayButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'videoReplayButton')
			},
			$_crsVd_styleVideoReplayButtonBlock() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoReplayButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_crsVd_styleVideoReplayButtonColor() {
				const self_ = this;
				const button_ =self_.$_crsVd_styleVideoReplayButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_crsVd_styleVideoReplayButtonDark() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoReplayButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_crsVd_styleVideoReplayButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoReplayButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_crsVd_styleVideoReplayButtonElevation() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoReplayButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_crsVd_styleVideoReplayButtonFlat() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoReplayButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_crsVd_styleVideoReplayButtonLarge() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoReplayButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_crsVd_styleVideoReplayButtonLight() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoReplayButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_crsVd_styleVideoReplayButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoReplayButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_crsVd_styleVideoReplayButtonRounded() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoReplayButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_crsVd_styleVideoReplayButtonSmall() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoReplayButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_crsVd_styleVideoOpenLinkButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'videoOpenLinkButton')
			},
			$_crsVd_styleVideoOpenLinkButtonBlock() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoOpenLinkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_crsVd_styleVideoOpenLinkButtonColor() {
				const self_ = this;
				const button_ =self_.$_crsVd_styleVideoOpenLinkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_crsVd_styleVideoOpenLinkButtonDark() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoOpenLinkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_crsVd_styleVideoOpenLinkButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoOpenLinkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_crsVd_styleVideoOpenLinkButtonElevation() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoOpenLinkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_crsVd_styleVideoOpenLinkButtonFlat() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoOpenLinkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_crsVd_styleVideoOpenLinkButtonLarge() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoOpenLinkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_crsVd_styleVideoOpenLinkButtonLight() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoOpenLinkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_crsVd_styleVideoOpenLinkButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoOpenLinkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_crsVd_styleVideoOpenLinkButtonRounded() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoOpenLinkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_crsVd_styleVideoOpenLinkButtonSmall() {
				const self_ = this;
				const button_ = self_.$_crsVd_styleVideoOpenLinkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
		},
		mounted() {
			const self_ = this;

			self_.player_ = self_.videojs(self_.$refs.videoPlayer, 
				{
					language: 'en',
					playbackRates: [0.7, 1.0, 1.5, 2.0],
					poster: self_.$_crsVd_videoLoadingImage,
					preload: 'metadata',

					autoplay: self_.$_crsVd_videoAutoPlay,
					controls: self_.$_crsVd_videoControls,
					muted: self_.$_crsVd_videoMuted,
					sources: [{
						type: 'video/mp4',
						src: self_.$_crsVd_videoUrl
					}]
				}, 
				function onPlayerReady() {
					self_.player_.on('play', () => {
						self_.video_ = {
							play: true
						}
						self_.$emit('play')
					})

					self_.player_.on('pause', () => {
						self_.video_ = {
							paused: true
						}
						self_.$emit('paused')
					})

					self_.player_.on('ended', () => {
						self_.video_ = {
							ended: true
						}
						self_.$emit('ended')
					})

					self_.player_.on('loadedmetadata', () => {
						self_.player_.poster(self_.$_crsVd_videoReadyImage)
					})
				}
			)
		},
		beforeDestroy() {
			const self_ = this;

			if (self_.player) {
				self_.player.dispose()
			}
		},
		methods: {
			$_crsVd_click() {
				const self_ = this;
				if(self_.video_.play) {
					self_.$_crsVd_pause()
				} else {
					self_.$_crsVd_play()
				}
			},
			$_crsVd_play() {
				const self_ = this;
				self_.player_.play()
			},
			$_crsVd_pause() {
				const self_ = this;
				self_.player_.pause()
			},
			$_crsVd_replay() {
				const self_ = this;
				self_.player_.currentTime(0)
				self_.player_.play()
			}			
		}
	}
</script>

<style scoped>
	.video-js.video_ .vjs-tech {
		border-radius: 0 !important;
	}
	@media screen and (min-width:960px) {
		.video-js.video_ .vjs-tech {
			height: calc(100vh - 64px);
		}
	}
	@media screen and (max-width:959px) {
		.video-js.video_ .vjs-tech {
			height: calc(100vh - 56px);
		}
	}
	.card_ {
		height: calc(100vh - 64px);
		width: 100vw;

		position: absolute;
		top: 0;
		left: 0;
	}
	.linear_ {
		margin-top: -24px;
	}
	.row_ {
		height: 100%;
	}
</style>
